import React from 'react'
import styles from './PopupEditChips.module.scss'
import { Modal } from 'components/Modal/Modal'
import { Button } from 'components/Button/Button'
import { Input } from 'components/Input/Input'

type Props = {
    onClose: () => void,
    title: string,
    name: string,
}

export function PopupEditChips(props: Props) {
    const [credentials, setCredentials] = React.useState({})

    function onSubmit(event: React.FormEvent<HTMLFormElement>) {
        event.preventDefault()
    }

    function handleCredentials(target) {
        setCredentials({
            ...credentials,
            [target.name]: target.value,
        })
    }

    function handleSubmit() {
        // add submit login
    }

    return (
        <Modal onClose={props.onClose}>
            <form className={styles['wrapper']} onSubmit={onSubmit}>
                <div className={styles['content']}>
                    <span className={styles['title']}>Edit link</span>
                    <Input
                        label={props.title}
                        type='text'
                        name={props.name}
                        onChange={handleCredentials}
                    />
                </div>
                <div className={styles['button']}>
                    <Button size='m' type='border' onClick={props.onClose}>
                        Cancel
                    </Button>
                    <Button size='m' type='dark' onClick={handleSubmit}>
                        Save
                    </Button>
                </div>
            </form>
        </Modal>
    )
}

